export default "__VITE_ASSET__2c1c0acc__"